function showMore(e) {
  const slider = $(e.currentTarget).closest('.testimonials-slider');
  const testimonialBlockId = $(e.currentTarget).data('blockid');
  const currentSlide = slider.slick('slickCurrentSlide');

  const testimonialLightbox = $(`.lightbox-${testimonialBlockId}`);
  const lightboxSlider = testimonialLightbox.find(
    '.lightbox-testimonials-slider'
  );

  testimonialLightbox.trigger('open');
  lightboxSlider.slick('slickGoTo', currentSlide);
  lightboxSlider.slick('refresh');
}

$(() => {
  // Onscreen testimonial sliders
  const sliders = $('.testimonials-slider');

  // Lightbox testimonial sliders
  const lightboxSliders = $('.lightbox-testimonials-slider');

  // Initialise slick on lightbox sliders
  lightboxSliders.each(function (idx, slider) {
    $(slider).slick({
      infinite: true,
      fade: true,
      adaptiveHeight: true,
      prevArrow: false,
      nextArrow: false
    });
  });

  // Initialise slick on homepage sliders
  sliders.each(function (idx, slider) {
    // Target the testimonials block as the element to have the dots appended
    const appendDots = $(slider).closest('.testimonials-block');

    $(slider).slick({
      infinite: true,
      prevArrow: false,
      nextArrow: false,
      dots: true,
      appendDots: appendDots,
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      pauseOnHover: true
    });
  });

  const testimonialsShowMoreButton = $('.testimonial-show-more');
  const lbSliderLeftArrow = $('.testimonials-lb-left-arrow');
  const lbSliderRightArrow = $('.testimonials-lb-right-arrow');

  testimonialsShowMoreButton.on('click', (e) => showMore(e));
  lbSliderLeftArrow.on('click', () => lightboxSliders.slick('slickPrev'));
  lbSliderRightArrow.on('click', () => lightboxSliders.slick('slickNext'));
});
